import DiscBrakeAdapterFinder from "../../../../src/content/posts/2020-06-27---disc-brake-adapter-finder/DiscBrakeAdapterFinder";
import * as React from 'react';
export default {
  DiscBrakeAdapterFinder,
  React
};